<template>
  <logged-in-layout>
    <main>
      <div :class="$style.header">
        <button @click="$router.go(-1)"><font-awesome-icon :icon="faArrowLeft" /></button>
        <h1>New Message</h1>
      </div>
      <SearchContacts :features="['SMS']" />
    </main>
  </logged-in-layout>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft'
  import LoggedInLayout from '@/components/logged-in-layout/logged-in-layout'
  import SearchContacts from '@/components/shared/SearchContacts/SearchContacts'

  export default {
    components: {
      LoggedInLayout,
      SearchContacts,
      FontAwesomeIcon
    },
    data () {
      return {
        faArrowLeft
      }
    }
  }
</script>

<style module lang="less" src="./new-message.less"></style>



// WEBPACK FOOTER //
// new-message.vue?64a2da5d